module.exports = __webpack_public_path__ + "static/manage-compliance-bg-079019e43ef4993c77ada0228d84d7a1.jpg";